import "js/lib/hello";
import "js/lib/focus";
//import 'js/lib/svg';

import "~/header/header";
import "~/nav/nav";
import "~/minicart/minicart";
import "~/slider/slider";
import "~/roll/roll";
import "~/map/map";
import "~/map-modal/map-modal";
import "~/filter/filter";
import "~/sort/sort";
import "~/product/product";
import "~/product-slider/product-slider";
import "~/product-order/product-order";
import "~/product-fold/product-fold";
import "~/tabs/tabs";
import "~/modal/modal";
import "~/gallery/gallery";
import "~/licenses/licenses";
import "~/noty/noty";
import "~/cart/cart";
import "~/cart-form/cart-form";
import "~/cookie/cookie";
